import PageContainer from './PageContainer';
import PageContainerContainer from './PageContainer.container';

export default PageContainerContainer(PageContainer);
